<script>
	// From Lucide
	import { ArrowRight } from 'lucide-svelte';

	export let iconClass = '';
</script>

<ArrowRight class={iconClass} />
